import React from "react";
import styled from "styled-components";
import { Row, Text, Title } from "../../../theme/";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 2em 0;
`;

const StyledRow = styled(Row)`
  width: 70%;
  margin: 1em auto;
  justify-content: center;
  text-align: center;
  @media (max-width: 780px) {
    width: 95%;
  }
`;

export default function Content() {
  return (
    <Wrapper>
      <StyledRow margin="1em 0 0 1em" width="50%">
        <Title>Customizable corporate packages</Title>
      </StyledRow>
      <StyledRow>
        <Text color="#2b2b2b">
          At AchieveCE, we specialize in creating custom CE packages for
          organizations of all sizes. Our team of writers can create custom
          courses and even tailor full packages to meet your needs. We’ll be
          happy to work with you on by offering flexible pricing and concierge
          support to ensure that both you and your employees are well taken care
          of. Our highest priority is ensuring that the content your employees
          are learning is of the greatest value to your organization.
        </Text>
      </StyledRow>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Corporate/components/Content.jsx